import { render, staticRenderFns } from "./HandoutDownloadLink.vue?vue&type=template&id=6859ef02"
import script from "./HandoutDownloadLink.vue?vue&type=script&lang=js"
export * from "./HandoutDownloadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports